import * as React from 'react'

function SvgGg(props) {
	return (
		<svg viewBox="-18 -12 36 24" width="1em" height="1em" {...props}>
			<path fill="#fff" d="M-18-12h36v24h-36z" />
			<path d="M0-12v24M-18 0h36" stroke="#e8112d" strokeWidth={6} fill="none" />
			<path id="gg_svg__a" d="M-9 2l1-1h9v-2h-9l-1-1z" fill="#f9dd16" />
			<use xlinkHref="#gg_svg__a" transform="rotate(90)" />
			<use xlinkHref="#gg_svg__a" transform="rotate(-90)" />
			<use xlinkHref="#gg_svg__a" transform="rotate(180)" />
		</svg>
	)
}

export default SvgGg
